import React from "react";
import { formatNumber } from "./charts/chartTheme";

/**
 * Per employee: one bar split into two parts, turnover (promet) and expense (rashod). The bar length is proportional to the sum
 * of both (relative to the employee with the largest sum), the parts show how that sum divides.
 * rows: [{ label, revenue, expense }]
 */
export default function EmployeeSplitBars({ rows }) {
  const max = Math.max(...rows.map((r) => (Number(r.revenue) || 0) + (Number(r.expense) || 0)), 0) || 1;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-600 dark:text-slate-300">
        <span className="inline-flex items-center gap-1.5">
          <span aria-hidden="true" className="h-2 w-2 rounded-sm bg-primary dark:bg-primary-light" />
          Promet
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span aria-hidden="true" className="h-2 w-2 rounded-sm bg-warning" />
          Rashod
        </span>
      </div>
      <ol className="flex flex-col gap-3">
        {rows.map((r, i) => {
          const revenue = Math.max(0, Number(r.revenue) || 0);
          const expense = Math.max(0, Number(r.expense) || 0);
          const total = revenue + expense;
          const width = Math.max(2, (total / max) * 100);
          const revenueShare = total > 0 ? (revenue / total) * 100 : 0;
          return (
            <li key={`${r.label}-${i}`}>
              <div className="flex items-baseline justify-between gap-3">
                <span className="line-clamp-2 min-w-0 text-sm text-slate-800 dark:text-slate-100">{r.label}</span>
                <span className="shrink-0 whitespace-nowrap text-sm font-semibold tabular-nums text-slate-900 dark:text-slate-50">
                  {formatNumber(total)} <span className="text-xs font-normal text-slate-500 dark:text-slate-400">RSD</span>
                </span>
              </div>
              <div className="mt-1.5 flex h-1.5 overflow-hidden rounded-sm" style={{ width: `${width}%` }}>
                <div className="h-full bg-primary dark:bg-primary-light" style={{ width: `${revenueShare}%` }} />
                <div className="h-full flex-1 bg-warning" />
              </div>
              <div className="mt-1 flex flex-wrap gap-x-4 text-xs tabular-nums text-slate-500 dark:text-slate-400">
                <span>Promet {formatNumber(revenue)}</span>
                <span>Rashod {formatNumber(expense)}</span>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
